import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e943f8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrap" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "protected-info van-hairline--top" }
const _hoisted_4 = { class: "xag-ellipsis" }
const _hoisted_5 = {
  key: 0,
  class: "empty-value"
}

import { withDefaults } from 'vue'
import { useRouter } from 'vue-router'
import { ThreeLiabiltyListItem } from '@/types/insurance'
import { serviceType } from '@/types/three-liability-insurance'

import dayjs from 'dayjs'
import CellWrap from './cell-wrap.vue'
import DeviceInfoItem from './device-info-item.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'receive-insurance-list',
  props: {
    list: { default: () => [] },
    hideEmpty: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { list: ThreeLiabiltyListItem[], hideEmpty?: boolean };


const router = useRouter()

function getReceiveDevice(item: ThreeLiabiltyListItem) {
  return {
    ...item,
    name: item.serial_number_name,
    sn: item.serial_number,
  }
}
function getEndTime(val: string) {
  let value = Number(val) * 1000
  return dayjs(value).format('YYYY-MM-DD HH:mm')
}

function toCheckDetail(item: ThreeLiabiltyListItem) {
  router.push({
    name: 'third-party-drone',
    query: {
      sn: item.serial_number,
      type: serviceType.ThirdPartyLiabilityService,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index + item.serial_number,
        onClick: ($event: any) => (toCheckDetail(item))
      }, [
        _createVNode(CellWrap, { class: "info" }, {
          default: _withCtx(() => [
            _createVNode(DeviceInfoItem, {
              data: getReceiveDevice(item)
            }, null, 8, ["data"])
          ]),
          _: 2
        }, 1024),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "被保人: " + _toDisplayString(item.insurant_name), 1),
          _createElementVNode("div", null, _toDisplayString(getEndTime(item.policy_end_date)) + " 到期", 1)
        ])
      ], 8, _hoisted_2))
    }), 128)),
    (!props.hideEmpty && (!props.list || !props.list.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "暂无数据"))
      : _createCommentVNode("", true)
  ]))
}
}

})